<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Forms - update">
      <div class="d-block">
        <form>
          <div class="form-group">
            <label for="form_title">Form title</label>
            <input
              type="text"
              class="form-control"
              id="form_title"
              placeholder="Form title"
              v-model="form_title"
            />
            <div class="invalid-feedback" v-if="errors.form_title">
              {{ errors.form_title[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="provider">Provider</label>
            <input
              type="text"
              class="form-control"
              id="provider"
              placeholder="Provider"
              v-model="provider"
            />
            <div class="invalid-feedback" v-if="errors.provider">
              {{ errors.provider[0] }}
            </div>
          </div>
          <div class="form-group">
            <label for="other1">Other title1</label>
            <input
              type="text"
              class="form-control"
              id="other1"
              placeholder="Other title1"
              v-model="other1"
            />
          </div>
          <div class="form-group">
            <label for="other2">Other title2</label>
            <input
              type="text"
              class="form-control"
              id="other2"
              placeholder="Other title2"
              v-model="other2"
            />
          </div>
          <div class="form-group">
            <label for="other2">Form</label>
            <div>
              <input
                type="file"
                class=""
                placeholder="Other title2"
                v-on:change="onChange"
              />
            </div>
          </div>

          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            Status
          </b-form-checkbox>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-primary btn-sm"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as formDownloadService from '../../services/formDownload.service'
export default {
  name: 'ModalFormsDownloadEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      form_title: '',
      provider: '',
      other1: '',
      other2: '',
      url: '',
      file: '',
      status: ''
    }
  },
  computed: {
    ...mapGetters(['gettFormDownloadAll'])
  },
  methods: {
    ...mapActions(['fetchFormDownloadAll']),
    fnShowModal() {
      this.fnGetValue(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetValue(props) {
      this.id = props.rowData.id
      this.form_title = props.rowData.form_title
      this.provider = props.rowData.provider
      this.other1 = props.rowData.other1
      this.other2 = props.rowData.other2
      this.url = props.rowData.url
      this.status = props.rowData.status
    },
    onChange(e) {
      this.file = e.target.files[0]
    },

    fnUpdate: async function () {
      const formData = new FormData()

      formData.append('form_title', this.form_title)
      formData.append('provider', this.provider)
      formData.append('other1', this.other1)
      formData.append('other2', this.other2)
      formData.append('file', this.file)
      formData.append('status', this.status)
      formData.append('_method', 'put')

      try {
        const response = await formDownloadService.update(this.id, formData)

        this.fetchFormDownloadAll()

        messageService.fnSweetAlertSuccessToast(
          'Forms',
          'Updated successfully '
        )
        this.hideModal()

        this.id = ''
        this.form_title = ''
        this.provider = ''
        this.other1 = ''
        this.other2 = ''
        this.file = ''
        this.status = ''
      } catch (error) {
        messageService.fnSweetAlertErrorToast(
          'Forms - update',
          error.response.data.message
        )
      }
    }
  }
}
</script>